import React, { Fragment } from 'react'
import TasksContainer from '@app/containers/students/Tasks'
import BonusTask from '@app/containers/students/BonusTask'
import Content from './Content'
import Logo from '@app/components/shared/Logo'
import { CompetitionPart } from '@app/components/shared/students/LandingPart'
import classnames from 'classnames'

const Results = ({ student, global }) => {
  const classes = classnames(
    'student-tasks-page',
    'student-tasks-page--results'
  )

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          <div className="student-tasks-page__content-wrapper">
            <div className="student-tasks-page__tasks-wrapper">
              <div className="student-tasks-page__panel translucent">
                <TasksContainer
                  student={student}
                  tour="main"
                  className="results"
                  ChildComponent={Content} />

                <BonusTask student={student} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CompetitionPart global={global} />
    </Fragment>
  )
}

export default Results
